import { get } from '@fable/api'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { useQuery, UseQueryResult } from 'react-query'
import { StreakMapResponse } from '../types'

export const getAnnualStreaks = async ({
  userId,
  year,
}: {
  userId: string
  year: number
}) => await get(`/v2/reading/streaks/annual?year=${year}&user_id=${userId}`)

export const useChartQuery = ({ enabled = false }: { enabled?: boolean }) => {
  const [year, userId] = useStats((s) => [s.year, s.statsUserId])
  const queryKey = ['stats-streaks-map', userId, year]

  const query: UseQueryResult<StreakMapResponse> = useQuery(
    queryKey,
    () => getAnnualStreaks({ userId, year }),
    {
      enabled: !!enabled && !!userId,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 0,
      cacheTime: 0,
    }
  )

  return query
}
